export default __webpack_public_path__ + "static/media/gloves.63d3bb76.svg";